import $ from 'jquery';
import _ from 'underscore';

var initializeIfNotReady = _.once(function () {
    // The following is taken from
    // https://developers.google.com/analytics/devguides/collection/analyticsjs/tracking-snippet-reference#alternative-async-tracking-snippet
    /* eslint-disable */
    window.ga = window.ga || function () {
        (ga.q = ga.q || []).push(arguments);
    };
    ga.l = +new Date();
    /* eslint-enable */
    // enable google analytics ecommerce plugin
    window.ga('require', 'ecommerce');

    $.ajax({
        url: 'https://www.google-analytics.com/analytics.js',
        dataType: 'script',
        cache: true
    });
});

export default (function () {
    // cannot return window.ga here directly, because although window.ga will be replaced
    // later, the caller would still point to the intermediary object defined above
    return function () {
        var _window;

        initializeIfNotReady();
        (_window = window).ga.apply(_window, arguments);
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-tracking-angular/adapters/googleAnalytics.js
// module id = 910
// module chunks = 0